<script>
import { HorizontalBar } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  extends: HorizontalBar,
  props: ['options','height','data', 'titre'],
  methods: {
    newData: function() {
      this.renderChart(
        this.chartData,
        {
          plugins: {
            datalabels: {
              anchor: 'end',
              align: 'end',
              offset:0,
              display: (context) => {
                var index = context.dataIndex;
                var value = context.dataset.data[index];
                return (value > 0);
              },
              formatter: function(value, context) {
                return context.dataset.labels[context.dataIndex];
              }
            }
          },
          tooltips: {enabled: false},
          legend: {
            position: 'right'
          },
          title: {
            display: true,
            fontSize: 20,
            text: this.titre
          },
          scales: {
            yAxes: [{

            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: '% de FSS'
              },
              ticks: {min: 0, suggestedMax: 100 },
              // stacked: true
            }]
          },
          animation: {
            duration: 500,
          },
        }
      )
    }
  },
  computed: {
    // sortedData: function() {
    //   return this.data.slice()
    //                   .sort((a,b) => (a.uniqueUsers < b.uniqueUsers) ? 1 : -1)
    // },
    labels() {
      return this.data.map(x => {
        if(x.label.length > 20) {
          var matches = x.label.match(/\b(\w)/g);
          var acronym = matches.join('');
          return acronym;
        }
        return x.label;
      });
    },
    pcntDev() {
      return this.data.map(x => x.dev);
    },
    pcntSoumis() {
      return this.data.map(x => x.soumis);
    },
    pcntEvalue() {
      return this.data.map(x => x.evalue);
    },
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            data: this.pcntDev,
            fill: true,
            // backgroundColor:
            backgroundColor: "rgb(236,211,116)",
            label: "Dev/M-à-J",
            labels: this.data.map(x => x.devAbs)
          },
          {
            data: this.pcntSoumis,
            fill: true,
            // backgroundColor: "#8325ff",
            backgroundColor: "rgb(24,179,88)",
            label: "Soumis",
            labels: this.data.map(x => x.soumisAbs)
          },
          {
            data: this.pcntEvalue,
            fill: true,
            // backgroundColor: "#25ffde",
            backgroundColor: "rgb(57, 154, 219)",
            label: "Évalué",
            labels: this.data.map(x => x.evalueAbs)
          },
        ]
      }
    }
  },
  components: {
    ChartDataLabels
  },
  watch: {
    data: function() {
      this.newData();
      // this.$data._chart.update();
      // this.update();
    }
  },
  mounted() {
    this.newData();
        this.addPlugin(ChartDataLabels);
    // this.renderChart(this.chartdata, this.options)
    // this.renderChart({data: [10,14,15]}, this.options)
  }
}
</script>
